import { AfterViewInit, Component, Input, OnInit, TemplateRef, ViewChild, ViewEncapsulation } from '@angular/core';
import { MatPaginator } from '@angular/material/paginator';
import { MatTableDataSource } from '@angular/material/table';
import { ITableColumnHeader } from 'src/app/models/table-column-header';

@Component({
  selector: 'sm-data-table-for-appointments',
  templateUrl: './data-table-for-appointments.component.html',
  styleUrls: ['./data-table-for-appointments.component.scss'],
   encapsulation: ViewEncapsulation.None
})
export class DataTableForAppointmentsComponent implements OnInit, AfterViewInit {
@Input() rowClickHandler!: (row: any) => void;

 private _dataSource: MatTableDataSource<any> = new MatTableDataSource<any>([]); 
  @Input() set dataSource(value: any[]){
    this._dataSource = new MatTableDataSource(value)
    this.totalPageItems = value.length;
    this._dataSource.paginator = this.pagination;
  }
  @Input()
  menuDropdownTemplate!: TemplateRef<any>;
  @Input()
  imageTemplate!: TemplateRef<any>;
  @Input() checkTemplate!: TemplateRef<any>;
  @Input() columnHeaders: ITableColumnHeader[] = [];
  @Input() showPagination: boolean = false;
  @Input() showMenuButton: boolean = false;
  @Input() showImageColumn: boolean = false;
  @Input() showFilter: boolean = false;
  @Input() itemsPerPage: number = 10;
  displayedColumns: string[] = [];
  @ViewChild(MatPaginator)
  pagination!: MatPaginator;
  totalPageItems: number = 0;


  constructor() {}

  ngAfterViewInit(){
    this._dataSource.paginator = this.pagination;
  }

  ngOnInit(): void {
    this.displayedColumns = this.columnHeaders.map(column => column.columnProperty).slice();
    if(this.showMenuButton){
      this.displayedColumns.push("menu");
    }
    if(this.showImageColumn){
      this.displayedColumns.unshift("image");
    }
    console.log(this.columnHeaders, this.displayedColumns);
  }

  onFilterData(ev: Event){
    const filterValue = (ev.target as HTMLInputElement).value;
    this._dataSource.filter = filterValue.trim().toLowerCase();
  }

  get dataSource(){
    return this._dataSource as any;
  }

  getBookingStatusClass(status: string, columnProperty: string): string {
    
    if (columnProperty === 'bookingStat') {
      // console.log(status,columnProperty);
      switch (status) {
        case 'New booking':
          return 'new-booking';
          
        case 'New':
          return 'new-booking';
          
        case 'Booking confirmed':
          return 'confirmed';
          
        case 'Confirmed':
          return 'confirmed';

        case 'In-progress':
          return 'under-process';

        case 'Under process':
          return 'under-process';

        case 'Partially Complete':
          return 'under-process';

        case 'Assigned':
          return 'under-process';

        case 'Completed':
          return 'completed';

        case 'Cancelled by User':
          return 'cancelled';

        case 'Cancelled by service provider':
          return 'cancelled';

        case 'Cancelled':
          return 'cancelled';
        case 'Absent':
          return 'cancelled';
        case 'Present':
          return 'new-booking';


           case 'New query':
          return 'new-booking';
        case 'Query in progress':
          return 'under-process';
        case 'Marked enrolled':
          return 'under-process';
        case 'Query cancelled':
          return 'cancelled';
        case 'Query enrolled':
          return 'completed';


        default:
          return 'status-default';
      }
    }
   
    if (columnProperty === 'item_status') {
      switch (status) {
        case 'New':
          return 'new-booking';
          
        case 'In progress':
          return 'under-process';
          
        case 'Marked as enrolled':
          return 'confirmed';
          
        case 'Cancelled':
          return 'cancelled';

        case 'Enrolled':
          return 'completed';

        default:
          return 'status-default';
      }
    }
    if (columnProperty === 'purchase_date') {
      switch (status) {
        case 'Reminder':
          return 'reminder';
          
       
        default:
          return 'status-default';
      }
    }
    if (columnProperty === 'at_status') {
      switch (status) {
        case 'Absent':
          return 'cancelled';
        case 'Present':
          return 'new-booking';
          
       
        default:
          return 'status-default';
      }
    }
   
    return '';
  }
}
